/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty-pattern */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import { CenterBox, ColDiv, RowDiv } from "../../components/misc/misc.styled";
import { Lbl } from "../../components/labels";
import { AppCSS, Spacer, TapButton, TxtInput } from "../../components";

import { useEffect, useState } from "react";
import { LoginContainer } from "./login.styled";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { userLogin } from "../../redux/reducers";
import { useLazyQuery } from "@apollo/client";

import {
  LOGIN_ADMIN_USER,
  RESET_PASSWORD_QUERY,
} from "../../apolloClient/operation/querys/userQuery";
import { setUserProperties, logEvent, AUTH_EVENTS } from "../../utils/amplitude";

import logo from "../../images/companylogo.png";

interface LoginProps {}

interface LoginData {
  adminLogin: {
    token: string;
  };
}

interface LoginVariables {
  email: string;
  password: string;
}

const commonCenterBoxStyle = {
  width: "100%",
  maxWidth: "420px",
  padding: "24px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#fff",
  overflow: "auto",
};

const commonTxtInputProps = {
  width: "100%",
  height: 44,
  borderColor: "#ccc",
  borderRadius: 8,
  paddingLeft: 12,
  textColor: "#000",
};

export const Login: React.FC<LoginProps> = ({}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [forgot, setForgot] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const profile = useAppSelector((state) => state.userReducer).userProfile;

  const [loginUser, { data, error }] = useLazyQuery<LoginData, LoginVariables>(
    LOGIN_ADMIN_USER
  );

  const [resetPassword, { data: resetPassData, error: resetPassError }] =
    useLazyQuery<{ resetPasswordAdmin: boolean }, { email: string }>(
      RESET_PASSWORD_QUERY, { fetchPolicy: "network-only" }
    );

  useEffect(() => {
    if (error) {
      console.error("Error occurred:", error);
      toast("Login failed! Please check your credentials.", {
        type: "error",
      });
      
      // Track failed login
      logEvent('login_failure', {
        email,
        error_message: error.message || "Login failed",
        timestamp: new Date().toISOString(),
      });
    }

    if (data && data.adminLogin && data.adminLogin.token) {
      localStorage.setItem("token", data.adminLogin.token);
      dispatch(userLogin({ token: data.adminLogin.token, _id: "" }));
      
      // Track successful login and identify user
      setUserProperties(email, { email });
      logEvent(AUTH_EVENTS.LOGIN_SUCCESS, {
        email,
        method: 'email',
        timestamp: new Date().toISOString(),
      });
      
      navigate("/dashboard");
    }
  }, [data, error, dispatch, navigate, email]);

  const onTapSignin = async () => {
    if (email === "" || password === "") {
      toast("Please enter email address and password!", {
        type: "error",
      });
      return;
    }

    loginUser({
      variables: {
        email: email,
        password: password,
      },
    });
  };

  const onTapResetPassword = async () => {
    if (email === "") {
      toast("Please enter email address!", {
        type: "error",
      });
      return;
    }

    try {
      const response = await resetPassword({
        variables: {
          email: email,
        },
      });

      if (response.data?.resetPasswordAdmin) {
        toast("Password reset email sent!", {
          type: "success",
        });
        
        // Track password reset request
        logEvent(AUTH_EVENTS.PASSWORD_RESET_REQUESTED, {
          email,
          timestamp: new Date().toISOString(),
        });
        
        setForgot(false)
      } else {
        toast("User doesn't exist!", {
          type: "error",
        });
      }
    } catch (error) {
      toast("An error occurred while sending the reset password email.", {
        type: "error",
      });
    }
  };

  const loginView = () => {
    return (
      <CenterBox style={commonCenterBoxStyle}>
        <img src={logo} alt="Logo" style={{ width: "180px" }} />
        <RowDiv>
          <Lbl title="Sign in" size={25} bold={500} />
        </RowDiv>

        <Spacer size={2} direction="col" />

        <ColDiv>
          <TxtInput
            placeholder="Email address"
            onChange={setEmail}
            {...commonTxtInputProps}
          />
          <Spacer size={1} direction="col" />
          <TxtInput
            type="password"
            placeholder="Password"
            onChange={setPassword}
            onPressEnter={onTapSignin}
            {...commonTxtInputProps}
          />
        </ColDiv>
        <Spacer size={2} direction="col" />
        <RowDiv
          style={{
            justifyContent: "space-between",
          }}
        >
          <TapButton
            onTap={() => setForgot(true)}
            title="Forgot Password"
            bgColor={AppCSS.WHITE}
            color={AppCSS.GLAS_GREEN}
            height={40}
          />
          <Spacer size={2} direction="row" />
          <TapButton
            onTap={onTapSignin}
            title="Sign In"
            bgColor={AppCSS.GLAS_BLUE}
            height={40}
          />
        </RowDiv>
        <Spacer size={2} direction="col" />
      </CenterBox>
    );
  };

  const forgotView = () => {
    return (
      <CenterBox style={commonCenterBoxStyle}>
        <img src={logo} alt="Logo" style={{ width: "180px" }} />
        <RowDiv>
          <Lbl title="Forgot Password" size={18} bold={600} />
        </RowDiv>
        <Spacer size={2} direction="col" />
        <ColDiv>
          <TxtInput
            placeholder="Email address"
            onChange={setEmail}
            {...commonTxtInputProps}
          />
        </ColDiv>
        <Spacer size={2} direction="col" />
        <RowDiv
          style={{
            justifyContent: "space-between",
          }}
        >
          <TapButton
            onTap={() => setForgot(false)}
            title="Cancel"
            color={AppCSS.GLAS_BLUE}
            bgColor={AppCSS.WHITE}
            borderColor={AppCSS.GLAS_BLUE}
            height={40}
          />
          <Spacer size={2} direction="row" />
          <TapButton
            onTap={onTapResetPassword}
            title="Reset Password"
            bgColor={AppCSS.GLAS_BLUE}
            height={40}
          />
        </RowDiv>
      </CenterBox>
    );
  };

  return <LoginContainer>{forgot ? forgotView() : loginView()}</LoginContainer>;
};

export default Login;
